<template>
    <div class="d-flex flex-column justify-center align-center">

        <v-row class="progress-bar-wrapper ma-0" v-if="showMobile">
            <v-col cols="12" class="position-relative">
                <v-progress-linear
                background-color="#EEECF8"
                color="#5746A1"
                v-model="completedTasksPercentage"
                height="18"
                class="pointer-events-none border-progress-bar"
                rounded
                >
                <strong>{{ question_number }} / {{ count_question }}</strong>
            </v-progress-linear>
                <v-img
                :src="require('@/assets/img/icons/check-stroke.png')"
                height="48"
                width="48"
                class="check-icon"
                ></v-img>
            </v-col>
        </v-row>


        <v-card-title data-cy="question-counterStep-title" class="text-justify text-h5 px-3 py-2 w-100">
            <div class="icon mr-2 d-flex justify-center">
                <!-- <v-icon color="primary" large>mdi-help-circle</v-icon> -->
                <v-img
                :src="require(`@/assets/img/icons/icon-voice-assistant.svg`)"
                max-height="40px"
                max-width="40px"
                :min-width="$vuetify.breakpoint.xs ? '32' : '40'"
                :min-height="$vuetify.breakpoint.xs ? '32' : '40'"
                contain
                class="cursor-pointer"
                @click="readTitle"
                ></v-img>
            </div>
                <p class="diagnostic-title mb-0">
                {{
                    `${$t('initialTour.question')} ${question_number} ${$t(
                        'initialTour.of'
                    )} ${count_question}`
                }}</p>
        </v-card-title>
        <v-row align="center" justify="center" class="px-4 mb-2 mt-2 diagnostic-question w-100">
            <span class="text-body-1 text-justify font-weight-regular w-100">
                {{ data.contenido }}
            </span>
            <v-row 
                data-cy="question-containerAnswers"
                v-for="answer of data.respuestas"
                :key="answer.id"
                class="w-100 ma-0 pa-0"
                align="center"
                justify="center"
                >
                <v-col cols="auto" class="pl-0">
                    <v-img
                        :src="require(`@/assets/img/icons/icon-voice-assistant.svg`)"
                        max-height="40px"
                        max-width="40px"
                        :min-width="$vuetify.breakpoint.xs ? '32' : '40'"
                        :min-height="$vuetify.breakpoint.xs ? '32' : '40'"
                        contain
                        class="cursor-pointer"
                       @click="readAnswer(answer.contenido)"
                        ></v-img>
                </v-col>
                <v-col
                    cols=""
                    v-ripple
                    :class="classSelected(answer.id)"
                    @click="setSelectedBtn(answer.id)"
                    elevation="0"
                >
                    {{ $utils.capitalizeWord(answer.contenido) }}
                </v-col>
            </v-row>
        </v-row>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import SpeechSynthesis from "@/mixins/SpeechSynthesis";

export default {
    props: {
        data: { type: Object, default: null },
        question_number: { type: [Number, String], default: 0 },
        count_question: { type: [Number, String], default: 0 },
        cleanSelection: { type: Number, default: 0 },
    },
    data() {
        return {
            btnSelected: null,
        }
    },
    computed: {
        ...mapState({
            showMobile: (state) => state.isMobile,
        }),
        completedTasksPercentage() {
            return (this.question_number) * 100 / this.count_question + 1
        },
    },
    methods: {
        classSelected(btnNumber) {
            const colorText = btnNumber === this.btnSelected ? 'white--text' : 'primary--text'
            return `w-100 my-3 transition-all cursor-pointer pa-2 border-radius-1 text-none option-btn ${colorText} ${this.bgColor(
                btnNumber
            )}`
        },
        bgColor(btnNumber) {
            return btnNumber === this.btnSelected ? 'primary' : ''
        },
        setSelectedBtn(btnNumber) {
            this.btnSelected = btnNumber
            this.$emit('newSelection', btnNumber)
        },
        readTitle() {
            console.log('readTitle')
            this.readText(`${this.$t('initialTour.question')} ${this.question_number} ${this.$t(
                        'initialTour.of'
                    )} ${this.count_question}.
                    ${this.data.contenido}`)
        },
        readAnswer(contenido) {
            this.readText(contenido)
        },
    },
    watch: {
        cleanSelection() {
            this.btnSelected = null
        },
    },
    mixins: [SpeechSynthesis],
}
</script>

<style scoped>
.diagnostic-question {
    height: 40vh;
    overflow: auto;
}
.diagnostic-question::-webkit-scrollbar-track{
    background-color: #EEECF8;
}
.diagnostic-question::-webkit-scrollbar-thumb {
    background-color: #7764CA;
}
.icon {
    border-radius: 500px;
}

.icon i {
    font-size: 24px;
    font-weight: bolder;
}

.option-btn {
    border: thin solid;
    border-color: #EEECF8;
    background: #EEECF8;
    font-size: 0.9rem;
    max-width: 100%;
}

::v-deep .progress-bar-wrapper .v-progress-linear .v-progress-linear__content {
    color: #C4BBE7;
}
</style>
